import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { LeafBranch, SmallSprig } from "../components/Botanical";
import { Play, Search, Music } from "lucide-react";

export default function OracoesIndex() {
  const [prayers, setPrayers] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/prayers")
      .then((res) => setPrayers(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const filtered = prayers.filter(
    (p) =>
      p.title.toLowerCase().includes(search.toLowerCase()) ||
      String(p.number).padStart(2, "0").includes(search)
  );

  return (
    <div className="relative min-h-screen overflow-hidden">
      <LeafBranch className="pointer-events-none absolute -top-4 -left-6 w-24 sm:w-32 opacity-20" />
      <LeafBranch flip className="pointer-events-none absolute top-1/3 -right-6 w-24 sm:w-32 opacity-20" />

      <div className="max-w-2xl mx-auto px-5 py-9 sm:py-12 relative z-10">
        {/* Masthead */}
        <header className="text-center border-b border-[#E5DCCF]/70 pb-6 mb-8 fade-up">
          <SmallSprig className="w-14 opacity-50 mx-auto mb-4" />
          <h1 className="font-cinzel uppercase text-[#3A2921] tracking-[0.22em] text-sm sm:text-base">
            Quando Faltam Palavras
          </h1>
          <p className="font-serif-display italic text-[#9C877A] text-sm sm:text-base mt-2 tracking-wide">
            50 Orações para Falar com Deus
          </p>
        </header>

        <p className="text-center text-[#6E5A4F] text-sm sm:text-base mb-7 fade-up delay-1">
          Escolha uma oração para ouvir. Respire fundo — este é o seu momento com Deus.
        </p>

        {/* Search */}
        <div className="relative mb-6 fade-up delay-1">
          <Search className="w-4 h-4 absolute left-4 top-1/2 -translate-y-1/2 text-[#9C877A]" />
          <input
            data-testid="oracoes-search-input"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Buscar oração por número ou título..."
            className="w-full rounded-full border border-[#E5DCCF] bg-[#FAF7F2] pl-11 pr-4 py-3 text-sm text-[#3A2921] outline-none focus:border-[#C5A059] transition-colors"
          />
        </div>

        {/* List */}
        <div className="flex flex-col gap-3 fade-up delay-2">
          {loading &&
            Array.from({ length: 6 }).map((_, i) => (
              <div key={i} className="h-[70px] rounded-2xl bg-[#F1E9DC] animate-pulse" />
            ))}

          {!loading &&
            filtered.map((p) => (
              <Link
                key={p.number}
                to={`/oracoes/${p.slug}`}
                state={{ fromIndex: true }}
                data-testid={`oracao-list-item-${p.number}`}
                className="group flex items-center gap-4 bg-[#FAF7F2] hover:bg-[#F4EFE6] border border-[#E5DCCF] rounded-2xl px-5 py-4 transition-all hover:border-[#C5A059]/60 hover:shadow-sm"
              >
                <span className="font-cinzel text-[#C5A059] font-semibold text-lg w-9 shrink-0">
                  {String(p.number).padStart(2, "0")}
                </span>
                <div className="flex-1 min-w-0">
                  <h2 className="font-serif-display text-xl text-[#3A2921] leading-snug truncate">
                    {p.title}
                  </h2>
                  {!p.has_audio && (
                    <span className="text-[11px] text-[#9C877A] italic">áudio em breve</span>
                  )}
                </div>
                <span className="w-10 h-10 rounded-full bg-[#3A2921] text-[#FDFBF7] flex items-center justify-center shrink-0 border border-[#C5A059]/40 group-hover:bg-[#5C4638] transition-colors">
                  {p.has_audio ? (
                    <Play className="w-4 h-4 ml-0.5" fill="currentColor" strokeWidth={0} />
                  ) : (
                    <Music className="w-4 h-4" strokeWidth={1.6} />
                  )}
                </span>
              </Link>
            ))}

          {!loading && filtered.length === 0 && (
            <p className="text-center text-[#9C877A] italic font-serif-display py-8">
              Nenhuma oração encontrada.
            </p>
          )}
        </div>

        <footer className="mt-10 flex items-center justify-center gap-1.5 text-[#C5A059]/70 text-xs">
          <SmallSprig className="w-8 opacity-50" />
          <span className="font-serif-display italic">feito com fé</span>
        </footer>
      </div>
    </div>
  );
}
